// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"921edb06","931":"4284f16a"}[chunkId] + ".chunk.css";
};